(ns frontend.view.settings2.module-management.view
  (:require [common.localization :as loc]
            [common.modules :as modules]
            [frontend.actions.tenant :as tenant-actions]
            [frontend.logging :as logging]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.not-found :as not-found]
            [frontend.view.settings2.module-management.mcp-terms.view :as mcp-terms]
            [frontend.view.settings2.sales-pipelines.db :as db]
            [reagent.core :as r]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.toggle.view :as toggle]))

(defn module-selector
  [{:keys [control-id value values edit? on-change]}]
  (let [teams @session/teams]
    [:div
     [:div
      [:div
       {:class-name (str "flex flex-col gap-3"
                         (when-not edit? ""))}
       (for [val values
             :let [found-in-teams? (and (contains? value val)
                                        (->> teams
                                             (some (fn [tm]
                                                     (contains? (:team/modules tm) val)))))]]
         ^{:key (str control-id "-checkbox-" val)}
         [:div
          {:class "p-3
                   flex justify-between items-center
                   border border-solid border-base-light-border-paler rounded"}
          [:span
           {:class "font-semibold"}
           (loc/tr val)]
          [:div
           {:class ""}
           found-in-teams?
           [tooltip/view
            {:disabled? (not found-in-teams?)}
            [:div
             [toggle/toggle
              {:type      "checkbox"
               :disabled? found-in-teams?
               :checked?  (contains? value val)
               :on-change (fn [& args]
                            (if (mcp-terms/terms-required? {:active-modules value
                                                            :module         val})
                              (mcp-terms/open-terms-modal! val)
                              (apply on-change val args)))}]]
            (loc/tr :modules/selector-disabled [(loc/tr val)])]]])]]]))

(defn module-management
  []
  (let [attribute :tenant/modules
        tenant-id (:db/id @session/tenant)
        entity-atom (r/cursor session/entities [tenant-id])
        all-modules (->> (modules/all-modules @session/tenant @session/tenant-plan)
                         (remove (fn [module]
                                   (= :module/dashboards-admin module)))
                         (sort))
        module (set (get @entity-atom attribute))]
    [:div
     {:class "h-[calc(100vh_-_52px-_37px)] overflow-auto relative"}
     [:div
      {:class "px-4 py-6 lg:mx-auto lg:w-4xl"}
      [:div
       {:class "flex flex-col gap-3"}
       [:div
        {:class "text-base-light-text font-bold text-xl"}
        (loc/tr :settings/module-management)]
       [module-selector
        {:value     module
         :values    all-modules
         :edit?     true
         :on-change (fn [v]
                      (let [updated-modules (if (contains? module v)
                                              (disj module v)
                                              (conj module v))]
                        ;;optimistic update:
                        (swap! entity-atom assoc attribute updated-modules)
                        (tenant-actions/*->update!
                         tenant-id
                         attribute
                         updated-modules
                         (fn [_])
                         (fn [e]
                           (logging/error "Unable to update modules" e)
                           ;;revert optimistic update:
                           (when (= (get @entity-atom attribute) updated-modules)
                             (swap! entity-atom assoc attribute module))))))}]]]]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/module-management)]])

(defn component
  []
  (r/create-class
   {:component-did-mount
    (fn [_])
    :component-will-unmount
    (fn [_])
    :reagent-render
    (fn []
      [:<>
       [zap-toolbar/view db/state breadcrumbs nil []]
       [module-management]])}))

(defmethod routing/render-view :settings/module-management
  [_]
  (if (session/is-admin?)
    [default-page-layout/view
     [component]]
    [not-found/not-found-view]))
